import classnames from 'classnames';
import React from 'react';
import { format, parseISO } from 'date-fns';
import { breakpoints } from '../../hooks/useResponsive';
import Icon from '../UI/Icon/Icon';
import Link from '../UI/Link/Link';
import WpImage, { imgSizes } from '../UI/WpImage/WpImage';
import * as styles from './EventCard.module.scss';

const EventCard = ({
  className,
  title,
  excerpt,
  image,
  uri,
  eventDetails,
  isPrimary = false,
  isHorizontal = false,
}) => {
  const classname = classnames(
    styles.container,
    {
      [ styles.isPrimary ]: isPrimary,
      [ styles.isHorizontal ]: isHorizontal,
    },
    className
  );

  const imgSize = isPrimary
    ? imgSizes.LARGE
    : isHorizontal
    ? imgSizes.THUMBNAIL
    : [
        { size: imgSizes.THUMBNAIL },
        {
          size: imgSizes.PORTRAIT_MEDIUM,
          media: `(min-width: ${breakpoints.medium}px)`,
        },
      ];

  return (
    <article className={classname}>
      {image && <WpImage className={styles.image} size={imgSize} {...image} />}

      <div className={styles.body}>
        { eventDetails.location &&
          <p className={styles.category}>
            <Icon className={styles.categoryIcon} name="map-pin" />
            <Link to={eventDetails.location.uri}>
              {eventDetails.location.title}
            </Link>
          </p>
        }        
        <h3 className={styles.title}>
          <Link to={uri}>{title}</Link>
        </h3>
        <p className={styles.byline}>
          {format(parseISO(eventDetails.eventDate), 'do MMMM yyy')}
        </p>

        {isPrimary && excerpt && <p className={styles.excerpt}>{excerpt}</p>}
      </div>
    </article>
  );
};

export default EventCard;
